import { TableCell as MuiTableCell, useMediaQuery } from '@mui/material';
import { CSSProperties, ComponentProps, FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { DraggableProvided } from 'react-beautiful-dnd';
import { WIDGETS_COLUMN_WIDTH } from './DetailTable';

type Props = ComponentProps<typeof MuiTableCell> &
	Readonly<{
		header?: boolean;
		isSticky?: boolean;
		dndRef?: DraggableProvided['innerRef'];
	}>;

const stickyStyles = (isSticky: boolean, isTabletOrSmaller: boolean): CSSProperties | null => {
	if (isTabletOrSmaller) {
		return null;
	}
	return {
		position: isSticky ? 'sticky' : 'relative',
		left: isSticky ? 0 : 'unset',
		zIndex: isSticky ? 2 : 'unset',
	};
};

const TableCell: FC<Props> = ({ header = false, isSticky = false, dndRef = undefined, ...props }) => {
	const theme = useTheme();
	const isTabletOrSmaller = useMediaQuery(() => theme.breakpoints.down('md'));

	return (
		<MuiTableCell
			sx={{
				minWidth: header ? WIDGETS_COLUMN_WIDTH : 294,
				fontSize: 14,
				border: `0.5px solid ${theme.palette.grey[200]}`,
				borderBottom: header ? 'none' : 'inherit',
				borderLeft: header ? 'none' : 'inherit',
				backgroundColor: header ? theme.palette.background.default : 'unset',
				fontWeight: header ? 500 : 'inherit',
				color: header ? '#777D89' : 'inherit',
				px: header ? 3 : 'unset',
				py: header ? 3 : 'unset',
				verticalAlign: 'top',
				':last-of-type': {
					borderBottom: `0.5px solid ${theme.palette.grey[200]}`,
				},
				...stickyStyles(isSticky, isTabletOrSmaller),
				...props.sx,
			}}
			ref={dndRef}
			{...props}
		/>
	);
};

export { TableCell };
